"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SExpressionFileParser = void 0;
const Iterator_1 = require("./Iterator");
function parseNode(iterator) {
    let word = iterator.current().trim();
    if (!word.startsWith('(') || !word.length) {
        throw new Error('Start of node does not match expected schema.');
    }
    if (word.endsWith(')')) {
        iterator.updateCurrent(word.slice(0, -1));
        return {
            name: word.slice(1, -1),
            values: [],
            nodes: [],
        };
    }
    const node = {
        name: word.slice(1),
        values: [],
        nodes: [],
    };
    iterator.next();
    do {
        word = iterator.current().trim();
        if (!word?.length) {
            continue;
        }
        else if (word.startsWith('(')) {
            node.nodes.push(parseNode(iterator));
        }
        else if (word.startsWith('"')) {
            node.values.push(parseNodeText(iterator));
        }
        else {
            const stripped = word.replace(/\)/g, '');
            if (stripped.length) {
                node.values.push(stripped);
            }
        }
        word = iterator.current().trim();
        if (word.endsWith(')')) {
            iterator.updateCurrent(word.slice(0, -1));
            return node;
        }
    } while (iterator.next());
    return node;
}
function parseNodeText(iterator) {
    const textEndMatch = /([\s\S]*")\)*$/g;
    let word = iterator.current().trim();
    if (!word.startsWith('"')) {
        throw new Error('Start of text object does not match expected schema.');
    }
    const match = textEndMatch.exec(word);
    if (match && match.length > 1) {
        return match[1];
    }
    let str = word;
    while (iterator.next()) {
        word = iterator.current().trim();
        const match = textEndMatch.exec(word);
        if (match && match.length > 1) {
            return str + ` ${match[1]}`;
        }
        str += ` ${word}`;
    }
    return str;
}
class SExpressionFileParser {
    constructor() {
        this.cache = new Map();
    }
    parseFile(filename, contents) {
        if (!this.cache.has(filename)) {
            this.cache.set(filename, SExpressionFileParser.Parse(contents));
        }
        return this.cache.get(filename);
    }
    static Parse(contents) {
        return parseNode(SExpressionFileParser.GetContentsIterator(contents));
    }
    static GetContentsIterator(contents) {
        return new Iterator_1.StatefulIterator(SExpressionFileParser.GetFileIterator(contents));
    }
    static *GetFileIterator(contents) {
        let wordStart = 0;
        let inQuotes = false;
        let i = 0;
        for (; i < contents.length; ++i) {
            const currentChar = contents[i];
            if (currentChar === '"') {
                if (inQuotes) {
                    let j = 0;
                    while (j < i && contents[i - j - 1] === '\\') {
                        j++;
                    }
                    const escapedQuote = j % 2 !== 0;
                    if (i > 0 && escapedQuote) {
                        continue;
                    }
                    yield contents.substring(wordStart, i + 1);
                    inQuotes = false;
                    wordStart = i + 1;
                    continue;
                }
                else {
                    inQuotes = true;
                    continue;
                }
            }
            if (inQuotes) {
                continue;
            }
            if (/\s/.test(currentChar)) {
                if (i === wordStart) {
                    wordStart = i + 1;
                    continue;
                }
                yield contents.substring(wordStart, i);
                wordStart = i + 1;
                continue;
            }
        }
        if (i > wordStart) {
            yield contents.substring(wordStart);
        }
    }
}
exports.SExpressionFileParser = SExpressionFileParser;
//# sourceMappingURL=NodeParser.js.map